module.exports = __webpack_public_path__ + "img/success-icon.e406d23d.png";